export default __webpack_public_path__ + "static/media/factory__29.af9d8cd0.jpg";